import { IRouteComponentProps } from 'umi';
import { Space } from 'antd';
import '@/static/css/common/common.less';
import styles from '@/static/css/common/theHeader.less';

type Props = {};

export default function EduHeader(props: IRouteComponentProps) {
  const { children } = props;
  const secondaryNavigationList = [
    {
      title: '学院首页',
      link: `${process.env.EDU_URL}`,
      selected: false,
    },
    {
      title: '学习路径',
      link: `${process.env.EDU_URL}/studypath/finereport`,
      selected: false,
    },
    {
      title: '打卡营',
      link: `${process.env.EDU_URL}/v2/camp`,
      selected: true,
    },
    {
      title: '视频课',
      link: `${process.env.EDU_URL}/video`,
      selected: false,
    },
    {
      title: '学习班',
      link: `${process.env.EDU_URL}/class`,
      selected: false,
    },
    {
      title: '直播',
      link: `${process.env.EDU_URL}/live`,
      selected: false,
    },
    {
      title: '城市课堂',
      link: `${process.env.EDU_URL}/cityclass`,
      selected: false,
    },
    {
      title: '讲师工作台',
      link: `${process.env.EDU_URL}/v2`,
      selected: false,
    },
    {
      title: '我的学习',
      link: `${process.env.EDU_URL}/v2/myStudy`,
      selected: false,
    },
  ];

  return (
    <>
      <div className={styles.secondary_navigation_wrapper}>
        <Space size={28} className={styles.secondary_navigation}>
          {secondaryNavigationList.map((item, index) => (
            <a
              key={index}
              className={
                item.selected
                  ? styles.secondary_navigation_item_active
                  : styles.secondary_navigation_item
              }
              href={item.link}
            >
              {item.title}
            </a>
          ))}
        </Space>
      </div>
      <div className="com_wrapper">
        <div className="com_wrapper_box">{children}</div>
      </div>
    </>
  );
}
